import DeniedServices from './DeniedServices';
export default DeniedServices;
